import io from 'socket.io-client'
import config from '../../config'
import auth from '@my/authentication'

let socket

export default {
  state: {
    io: {},
    socket: {},
    timeout: ''
  },

  mutations: {
    connectSocket (state) {
      if (!state.socket.connected) {
        const token = auth.getToken() || ''
        socket = io(config.SOCKETIO.connection, { query: { token } })
        state.socket = socket

        state.socket.on('disconnect', () => {
          this.commit('reconnectSocket')
        })

        state.socket.on('newData', message => {
          this.commit(`newData`, message)
        })

        state.socket.on('updateData', message => {
          this.commit(`updateData`, message)
        })

        state.socket.on('deleteData', message => {
          this.commit('deleteData', message)
        })

        state.socket.on('updateCart', message => {
          this.commit('updateCart', message)
        })

        state.socket.on('updateNewProducts', message => {
          this.commit('updateNewProducts', message)
        })

        state.socket.on('updateStatus', message => {
          this.commit('updateStatus', message)
        })

        state.socket.on('updateStatusChangeApproved', message => {
          this.commit('updateStatusChangeApproved', message)
        })

        state.socket.on('updateStatusChangePaid', message => {
          this.commit('updateStatusChangePaid', message)
        })

        state.socket.on('updateStatusPaid', message => {
          this.commit('updateStatusPaid', message)
        })

        state.socket.on('updatePayManual', message => {
          this.commit('updatePayManual', message)
        })

        state.socket.on('updatePayManualChange', message => {
          this.commit('updatePayManualChange', message)
        })

        state.socket.on('updatePayU', message => {
          this.commit('updatePayU', message)
        })

        state.socket.on('updateStatusPacked', message => {
          this.commit('updateStatusPacked', message)
        })

        state.socket.on('updateStatusPackedChange', message => {
          this.commit('updateStatusPackedChange', message)
        })

        state.socket.on('updateStatusSent', message => {
          this.commit('updateStatusSent', message)
        })

        state.socket.on('updateStatusSentChange', message => {
          this.commit('updateStatusSentChange', message)
        })

        state.socket.on('updateStatusDeclined', message => {
          this.commit('updateStatusDeclined', message)
        })

        state.socket.on('updateStatusDeclinedChange', message => {
          this.commit('updateStatusDeclinedChange', message)
        })

        state.socket.on('updateStatusExpired', message => {
          this.commit('updateStatusExpired', message)
        })

        state.socket.on('addObservation', message => {
          this.commit('addObservation', message)
        })

        state.socket.on('updateOrderNotifications', message => {
          this.commit('updateOrderNotifications', message)
        })

        state.socket.on('addObservationChange', message => {
          this.commit('addObservationChange', message)
        })

        state.socket.on('updateStatusInProgress', message => {
          this.commit('updateStatusInProgress', message)
        })

        state.socket.on('updateStatusDeliveryDeclined', message => {
          this.commit('updateStatusDeliveryDeclined', message)
        })

        state.socket.on('updatePackReceived', message => {
          this.commit('updatePackReceived', message)
        })

        state.socket.on('updateStatusDelivered', message => {
          this.commit('updateStatusDelivered', message)
        })

        state.socket.on('updateDeliveryPaid', message => {
          this.commit('updateDeliveryPaid', message)
        })

        state.socket.on('updateChargeCollected', message => {
          this.commit('updateChargeCollected', message)
        })

        state.socket.on('addObservationDelivery', message => {
          this.commit('addObservationDelivery', message)
        })
      }
    },

    reconnectSocket (state) {
      if (!state.socket.connected && !state.socket.connecting) {
        console.log('Conecting...')
        state.socket.close()
        state.socket.open()
        state.timeout = setTimeout(() => {
          this.commit('reconnectSocket')
        }, 3000)
      } else {
        clearTimeout(state.timeout)
        state.timeout = ''
        console.log('Connected')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/io.js